import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import SmelterForm from '../components/forms/SmelterForm'


const Smelter = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Direct Smelters Entry' text='Please complete the registration form' />
            <SmelterForm />
            <Banner />
            <Footer />
        </div>
    )
}

export default Smelter;
